import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareTldvCopy } from "../lib/translations/pages/compare-tldv";

export function CompareTldv() {
  const lang = useLang();
  return <ComparePage copy={compareTldvCopy[lang]} path="/compare/tldv-vs-minuta" />;
}
